module.exports = "<div class=\"d-flex justify-content-center align-items-center h-100\"><spinner relative=\"true\"></spinner></div>";